import Vue from 'vue'
import App from './App.vue'
import 'viewerjs/dist/viewer.css'
import VueTouch from 'vue-touch'
import router from './router'
import store from './store'
import vuexI18n from 'vuex-i18n'
import localStorage from 'vue-localstorage'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import 'vuetify/src/stylus/main.styl'

import { translationsEn } from './store/i18n/en'
import { translationsTh } from './store/i18n/th'

Vue.config.productionTip = false
Vue.use(VueTouch)
Vue.use(vuexI18n.plugin, store)
Vue.use(localStorage)
Vue.use(Vuetify)

Vue.i18n.add('en', translationsEn)
Vue.i18n.add('th', translationsTh)

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js